
import { Component, Vue } from 'vue-property-decorator'

/**
 * 水平線の規定コンポーネント
 *   HTML5以降、ただ水平線を引く場合は非推奨となっているため注意して使用する
 */
@Component
export default class HorizontalLine extends Vue {}
